import type { LocaleMessageBundle } from '../../types'
export const activityLogMessages: LocaleMessageBundle = {
  vi: {
    'activity.title': 'Lịch sử hệ thống',
    'activity.filters.keyword': 'Tìm người thao tác, hành động hoặc mã request',
    'activity.fields.time': 'Thời gian',
    'activity.fields.actor': 'Người thao tác',
    'activity.fields.action': 'Hoạt động',
    'activity.fields.target': 'Đối tượng',
    'activity.fields.result': 'Kết quả',
    'activity.fields.severity': 'Mức độ',
    'activity.fields.device': 'IP / thiết bị',
    'activity.fields.changedField': 'Trường thay đổi',
    'activity.fields.oldValue': 'Giá trị cũ',
    'activity.fields.newValue': 'Giá trị mới',
    'activity.detail': 'Chi tiết hoạt động',
    'activity.before': 'Dữ liệu trước',
    'activity.after': 'Dữ liệu sau',
    'activity.noChanges': 'Không có thay đổi trường dữ liệu',
    'activity.empty': 'Chưa có hoạt động trong khoảng thời gian này',
    'activity.result.success': 'Thành công',
    'activity.result.denied': 'Bị từ chối',
    'activity.result.failed': 'Thất bại',
    'activity.severity.info': 'Thông tin',
    'activity.severity.warning': 'Cảnh báo',
    'activity.severity.critical': 'Nghiêm trọng',
    'activity.actions.table_session.opened': 'Đã mở phiên bán theo bàn offline',
    'activity.actions.table_session.order_saved': 'Đã lưu đơn bán theo bàn',
    'activity.actions.table_session.checked_out': 'Đã thanh toán bán hàng theo bàn offline',
    'activity.actions.table_session.cancelled': 'Đã hủy phiên bán theo bàn',
    'activity.actions.table_session.start_time_adjusted': 'Đã điều chỉnh giờ bắt đầu',
    'activity.actions.table_session.transferred': 'Đã chuyển bàn từ dữ liệu offline',
    'activity.actions.booking.created': 'Đã tạo lịch đặt bàn offline',
    'activity.actions.booking.updated': 'Đã cập nhật lịch đặt bàn offline',
    'activity.actions.booking.extended': 'Đã gia hạn lịch đặt bàn offline',
    'activity.actions.booking.cancelled': 'Đã hủy lịch đặt bàn offline',
    'activity.actions.booking.checked_in': 'Đã nhận bàn từ lịch đặt offline',
    'activity.actions.staff.created': 'Đã tạo nhân viên',
    'activity.actions.staff.updated': 'Đã cập nhật nhân viên',
    'activity.actions.staff.deleted': 'Đã xóa nhân viên',
    'activity.actions.role.created': 'Đã tạo vai trò',
    'activity.actions.role.updated': 'Đã cập nhật vai trò',
    'activity.actions.role.deleted': 'Đã xóa vai trò',
    'activity.actions.role.permissions_synced': 'Đã cập nhật quyền của vai trò',
    'activity.verbs.created': 'Tạo',
    'activity.verbs.updated': 'Cập nhật',
    'activity.verbs.deleted': 'Xóa',
    'activity.verbs.restored': 'Khôi phục',
    'activity.targets.table_session': 'Phiên bán theo bàn',
    'activity.targets.booking': 'Lịch đặt bàn',
    'activity.targets.staff': 'Nhân viên',
    'activity.targets.role': 'Vai trò',
    'activity.targets.permission': 'Quyền',
    'activity.targets.product': 'Sản phẩm',
    'activity.targets.sales_invoice': 'Hóa đơn',
    'activity.targets.table_session_order': 'Đơn bán theo bàn',
  },
  en: {
    'activity.title': 'System history',
    'activity.filters.keyword': 'Search actor, action or request ID',
    'activity.fields.time': 'Time',
    'activity.fields.actor': 'Actor',
    'activity.fields.action': 'Activity',
    'activity.fields.target': 'Target',
    'activity.fields.result': 'Result',
    'activity.fields.severity': 'Severity',
    'activity.fields.device': 'IP / device',
    'activity.fields.changedField': 'Changed field',
    'activity.fields.oldValue': 'Old value',
    'activity.fields.newValue': 'New value',
    'activity.detail': 'Activity details',
    'activity.before': 'Before',
    'activity.after': 'After',
    'activity.noChanges': 'No data fields changed',
    'activity.empty': 'No activity in this date range',
    'activity.result.success': 'Success',
    'activity.result.denied': 'Denied',
    'activity.result.failed': 'Failed',
    'activity.severity.info': 'Information',
    'activity.severity.warning': 'Warning',
    'activity.severity.critical': 'Critical',
    'activity.actions.table_session.opened': 'Opened an offline table session',
    'activity.actions.table_session.order_saved': 'Saved table order',
    'activity.actions.table_session.checked_out': 'Completed offline table sale',
    'activity.actions.table_session.cancelled': 'Cancelled table session',
    'activity.actions.table_session.start_time_adjusted': 'Adjusted table session start time',
    'activity.actions.table_session.transferred': 'Transferred an offline table session',
    'activity.actions.booking.created': 'Created an offline booking',
    'activity.actions.booking.updated': 'Updated an offline booking',
    'activity.actions.booking.extended': 'Extended an offline booking',
    'activity.actions.booking.cancelled': 'Cancelled an offline booking',
    'activity.actions.booking.checked_in': 'Checked in an offline booking',
    'activity.actions.staff.created': 'Created staff member',
    'activity.actions.staff.updated': 'Updated staff member',
    'activity.actions.staff.deleted': 'Deleted staff member',
    'activity.actions.role.created': 'Created role',
    'activity.actions.role.updated': 'Updated role',
    'activity.actions.role.deleted': 'Deleted role',
    'activity.actions.role.permissions_synced': 'Updated role permissions',
    'activity.verbs.created': 'Created',
    'activity.verbs.updated': 'Updated',
    'activity.verbs.deleted': 'Deleted',
    'activity.verbs.restored': 'Restored',
    'activity.targets.table_session': 'Table session',
    'activity.targets.booking': 'Booking',
    'activity.targets.staff': 'Staff',
    'activity.targets.role': 'Role',
    'activity.targets.permission': 'Permission',
    'activity.targets.product': 'Product',
    'activity.targets.sales_invoice': 'Invoice',
    'activity.targets.table_session_order': 'Table order',
  },
}
